import React from "react";
import "./App.css";
import DisplayWeather from "./components/DisplayWeather";

function App() {
  return (
    <div className="App">
      <DisplayWeather />
    </div>
  );
}

export default App;
